

<template>
  <div id="every">
    <!-- <video v-if="this.$route.path !== '/obavijesti' && this.$route.path !== '/predavanja' && this.$route.path !== '/sponzori'" src="./assets/gifek.mp4" id="v0" muted autoplay loop type="video/mp4">
                </video> -->
    <div id="naslov">
      <div class="bgg">
        <!-- <div class="pozadina">
          <img src="./assets/pozad.png" alt="">
        </div> -->
        <div class="container">
          <div class="glitch botics" data-text="FIGHTBOTICS">FIGHTBOTICS</div>
        </div>
        <span class="cutcorner"></span>
      </div>
    </div>
    <div class="shill">
        <div class="tekst">
          <p class="Titlecard">
            <span class="var">let </span>
            <span class="ime">Wtf_Even_Is</span>
            <span class="dvot">:</span>
            <span class="tip"> string</span>
            <span class="jedn"> =</span>
            <span class="cont"> "Fightbotics?"</span>
            <span class="semi">;</span>
          </p>
          <p>
            Fightbotics je projekt u organizaciji studenata FSB-a i FER-a, koji okupljenim sudionicima daje priliku da
            izrade svoje borbene robote, upogone ih i međusobno se bore na jedinstvenom događaju.
            Natjecanje okuplja studente, srednjoškolce, hobiste i tvrtke te je otvoreno i besplatno za sve. <br />
            U suradnji s <a href="https://radiona.org/">Radionom-Makerspace Zagreb</a> i <a
              href="https://www.fsb.unizg.hr/index.php?fsbonline">Fakultetom Strojarstva i Brodogradnje</a>, organiziramo
            uvodno predavanje (otvoreno za sve) te praktične radionice (dostupne samo za odabrane studentske timove).
            Odabrani studentski timovi koji sudjeluju u našim radionicama imaju priliku naučiti kako dizajnirati i
            sastaviti osmišljene robote!
          </p>
        </div>
        <div class="sliks">
          <img class="artikl" src="./assets/bg.jpg" alt="">
        </div>
        <span class="cutcorner1"></span>
      </div>
      <div class="shill dos">
        <div class="sliks">
          <p class="Titlecard">
            <span class="var">var </span>
            <span class="ime">Da_Rulez</span>
            <span class="dvot">:</span>
            <span class="tip"> string</span>
            <span class="jedn"> =</span>
            <span class="cont"> "Pravila i propisi"</span>
            <span class="semi">;</span>
          </p>
          <p>
            <span class="spanspace">Zanimaju te koja oružja smiješ, a koja ne smiješ koristiti? Koliku mrcinu od robota smiješ napraviti? Sve možeš pogledati u
              našim pravilnicima!</span>
          </p>
          <div class="rulz">
            <p class="rulz">
              <span class="var">var </span>
              <span class="ime">rulz</span>
              <span class="dvot">:</span>
              <span class="tip"> array</span>
              <span class="jedn"> =</span> [ <br />
              <a class="linkk" href="./media/prijava.pdf" download>Vodić za prijavu na natjecanje,</a><br />
              <a class="linkk" href="./media/izrada.pdf" download>Pravilnik izrade robota,</a><br />
              <a class="linkk" href="./media/pravnatj.pdf" download>Pravila tijekom natjecanja</a>]<br />

            </p>
          </div>
        </div>
        <div class="tekst">
          <img class="artikl" src="./assets/egg.png" alt="">
        </div>
        <span class="cutcorner"></span>
      </div>
    <div class="shill">
      <div class="tekst">
        <p class="Titlecard">
          <span class="var">let </span>
          <span class="ime">Event_Name</span>
          <span class="dvot">:</span>
          <span class="tip"> string</span>
          <span class="jedn"> =</span>
          <span class="cont"> "FIGHT! botics"</span>
          <span class="semi">;</span>
        </p>
        <p class="spanspace">Sada kada znaš sve o nama, želiš li svojeg prijatelja izazvati na ultimativni okršaj borbi robota?</p>
        <br />
        <p class="spanspace">E pa sada upravo imaš priliku za to!</p>
        <br />
        <p class="spanspace">Okupi svoj tim, izradi robota i bori se na Fightbotics-studentskim borbama robota!</p>
        <br />
        <div class="testing"><a class="prijava" href="https://docs.google.com/forms/d/e/1FAIpQLSdC5pUTZO8KR9m2bxBeywOihql2YsyXGs4d_LYNwO2AnMiivw/viewform?usp=sf_link">Prijavi se!</a></div>
      </div>
      <div class="sliks">
        <img class="artikl" src="./assets/kuzma.jpg" alt="">
      </div>
    </div>
    <div class="kontakt">
      <p class="kontaktiraj">Zaprati nas na društvenim mrežama!</p>
      <div class="ikonice">
        <div class="div1"><a href="https://www.facebook.com/Fightbootics"><img class="sizeup" src="./assets/fejs.png" alt=""></a></div>
<div class="div2"><a href="https://www.instagram.com/fightbotics/"><img class="sizeup" src="./assets/insta.png" alt=""></a></div>
<div class="div3"><a href="https://www.youtube.com/channel/UCcTCUVs27ofXjj2AuakNBjQ"><img class="sizeup yt" src="./assets/youtube.png" alt=""></a></div>
<div class="div4"><a href="https://discord.gg/9wCf64Nr59"><img class="sizeup" src="./assets/discord.png" alt=""></a></div>

      </div>
    </div>
    <footer>
      <div class="ikonice2">
        <div class="div1">
          <span class="boja">Vedran Kocijan,</span> voditelj projekta 
                <p class="Kon">
                     vekikoc@gmail.com
                </p>
                <p class="Br">
                    +385 95 727 1254
                </p>
        </div>
        <div class="div2">
          <span class="boja">Marta Vukoja,</span> suvoditelj 
                <p class="Kon">
                     vukojamarta@gmail.com
                </p>
                <p class="Br">
                    +385 92 378 2667
                </p>
        </div>
        <div class="div3">
                <span class="boja">Dorian Erić,</span> suvoditelj 
                <p class="Kon">
                     dorian.eric@gmail.com
                </p>
                <p class="Br">
                    +385 98 367 426
                </p>
        </div>
        <div class="div4">
                <span class="boja">Hana Ilijazović,</span> suvoditelj 
                <p class="Kon">
                  hana.ilijazovic@gmail.com
                </p>
                <p class="Br">
                  +385 91 933 0914
                </p>
        </div>
      </div>
      <div>Copyright Fightbotics, 2023.</div>
  </footer>
</div></template>

<script>

export default {
  components: {
  }
}
</script>

<style lang="scss">

@font-face {
    font-family: "Jetbrains";
    src: url("./assets/fonts/JetBrainsMono-Regular.woff2") format('woff2'),
    url("./assets/fonts/JetBrainsMono-Regular.ttf") format('truetype');
}

.artikl {
  width: 50%;
}

a {
  margin: 2vh 0 0 2vh;
  text-decoration: none;
    color: rgb(78, 201, 162);
}



p {
  font-size: 1.8vh;
}

#every {
  min-height:100%;
  position:relative;
}

html, body {
  // background-color: rgb(30, 30, 30);
  color: rgb(212, 212, 212);
  padding: 0;
  margin: 0;
  overflow-x: hidden;
  height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: 'Jetbrains';
  scrollbar-width: none;
  background-image: url("./assets/pozad.png");
}

::-webkit-scrollbar {
    display: none;
}

.pozadina {
  position: absolute;
  top: 0;
  margin-top: 0;
  margin-bottom: 0;
  z-index: -1;
  object-fit: fill;
}

#v0 {
  opacity: 1;
    width: 50%;
}

footer {
  position: absolute;
  border-top: 2px solid rgba(58, 58, 58, 0.774);
  background-color:rgb(30, 30, 30);
  bottom: 0px;
  width: 100%;
}

.footie {
  display: inline-block;
  vertical-align: middle;
}

.cutcorner{
  bottom: 0;
left: 0;
border-width: 150px 0 0 150px;
border-color: transparent transparent transparent rgb(30, 30, 30);
width: 0;
height: 0;
z-index: 1;
border-style: solid;
position: absolute;
}

.cutcorner1{
  bottom: 0;
right: 0;
border-width: 150px 150px 0 0;
border-color: transparent  rgba(83, 50, 179, 1) transparent transparent;
width: 0;
height: 0;
z-index: 1;
border-style: solid;
position: absolute;
}


.shill {
  position: relative;
display: grid;
grid-template-columns: repeat(2, 1fr);
grid-template-rows: 1fr;
grid-column-gap: 0px;
grid-row-gap: 0px;
width: 100%;
  background-color: rgb(30, 30, 30);
}

.tekst { grid-area: 1 / 1 / 2 / 2;
  margin-top: 10vh; }
.sliks { grid-area: 1 / 2 / 2 / 3;
  margin-bottom: 10vh;
  margin-top: 10vh; } 


#naslov {
    width: 100%;
    height: 100vh;
    display: table;
    overflow: auto;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-top: 35vh;
  // margin-bottom: 35vh;

}

.bgg {
  position: relative;
  top: 0;
  margin-top: 0;
  margin-bottom: 0;
  height: 100vh;
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
@mixin glitchCopy { 
		content: attr(data-text);
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
}

.glitch {
	position: relative;
	color: rgb(212, 212, 212);
	font-size: 6vw;
  letter-spacing: 0.3em;
	animation: glitch-skew 1s infinite linear alternate-reverse;
	
	&::before{
		@include glitchCopy;
		left: 2px;

		text-shadow: -2px 0 #ff00c1;

		clip: rect(44px, 450px, 56px, 0);

		animation: glitch-anim 5s infinite linear alternate-reverse;
	}
	
	&::after {
		@include glitchCopy;
		left: -2px;
		text-shadow: -2px 0 #00fff9, 2px 2px #ff00c1;
		animation: glitch-anim2 1s infinite linear alternate-reverse;
	}
}


@keyframes glitch-anim {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100)+px, 9999px, random(100)+px, 0);
			transform: skew((random(100) / 100) + deg);
    }
  }
}


@keyframes glitch-anim2 {
  $steps: 20;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      clip: rect(random(100)+px, 9999px, random(100)+px, 0);
			transform: skew((random(100) / 100) + deg);
    }
  }
}


@keyframes glitch-skew {
  $steps: 10;
  @for $i from 0 through $steps {
    #{percentage($i*(1/$steps))} {
      transform: skew((random(10) - 5) + deg);
    }
  }
}
/////////////////////////////////////////////GUMB///////////////////////////////////////////////////////////////

.testing {
    display: block;
    position: relative;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    margin-top: 50px;
    margin-left: 10vw;
    margin-right: 10vw;
    margin-bottom: 3vh;
    padding: 8px 30px;
    font-size: 3vh;
    letter-spacing: .35em;
    text-align: center;
    text-transform: uppercase;
    border: 1px solid hsla(0,0%,100%,.2);
    transition: all .2s ease;
    color: #fff;
    background-color: rgba(40, 70, 189, 0.5);
  
    &:before, 
    &:after {
      content: 'Prijavi se';
      position: absolute;
        top: 0;
        left: 0;
      padding: 8px 0;
      width: 100%;
      -webkit-clip: rect(0px, 0px, 0px, 0px);
      clip: rect(0px, 0px, 0px, 0px);
      background: #fff;
      color: #000;
    }
    
    &:before {
      left: -3px;
      top: -2px;
      text-shadow: 2px 0 #fff;
      box-shadow: 2px 0 #fff;
    }
  
    &:after {
      left: 2px;
      bottom: -2px;
      text-shadow: -1px 0 #fff;
      box-shadow: -1px 0 #fff;
    }
  
    &:hover {
      background: white;
      color: black;
    }
  
    &:hover:before {
        animation: glitch-test 1.5s infinite linear alternate-reverse;
    }
    
    &:hover:after {
        animation: glitch-test 2s infinite linear alternate;
    }
  
}

@keyframes glitch-test {
  0% {
    clip: rect(-3px, 600px, 0px, 0px);
  }
  5.88235% {
    clip: rect(0px, 600px, 0px, 0px);
  }
  11.76471% {
    clip: rect(-3px, 600px, 0px, 0px);
  }
  17.64706% {
    clip: rect(-3px, 600px, 0px, 0px);
  }
  23.52941% {
    clip: rect(100px, 600px, 100px, 0px);
  }
  29.41176% {
    clip: rect(0px, 600px, 600px, 0px);
  }
  35.29412% {
    clip: rect(100px, 600px, 0px, 0px);
  }
  41.17647% {
    clip: rect(0px, 600px, 600px, 0px);
  }
  47.05882% {
    clip: rect(100px, 600px, 0px, 0px);
  }
  52.94118% {
    clip: rect(-3px, 600px, 0px, 0px);
  }
  58.82353% {
    clip: rect(100px, 450px,100px, 0px);
  }
  64.70588% {
    clip: rect(0px, 450px, 0px, 0px);
  }
  70.58824% {
    clip: rect(100px, 450px, 100px, 0px);
  }
  76.47059% {
    clip: rect(0px, 450px, 0px, 0px);
  }
  82.35294% {
    clip: rect(0px, 450px, 0px, 0px);
  }
  88.23529% {
    clip: rect(0px, 450px, 0px, 0px);
  }
  94.11765% {
    clip: rect(0px, 450px, 0px, 0px);
  }
  100% {
    clip: rect(0px, 450px, 0px, 0px);
  }
}

//TEKST CSS////////////////////////////////////////////////////////////////////////////////////////////

.kontaktiraj {
  font-size: 4vh;
}

.spanspace {
  margin: 1vh 0 1vh 0;
}

.Titlecard {
  font-size: 3.5vh;
}

.var {
  color: rgb(37, 102, 202);
}

.ime{
  color: rgb(156, 220, 254);
}

.dvot {
  color: white;
}

.tip {
  color: rgb(78, 201, 162);
}

.jedn {
  color: white;
}

.cont {
  color: rgb(195, 145, 91);
}

.semi {
  color: white;
}

.Kon {
    font-size: 1.75vh;
    color: rgb(195, 145, 91);
}

.Br {
    font-size: 1.75vh;
    font-style: italic;
    color: rgb(37, 102, 202);
}
.kont {
    margin-top: 0h;
    margin-bottom: 5vh;
}

.boja {
    color: rgb(78, 201, 162);
}

///////////////////////////////////////////////////////////////////////////////////

.dos {
  background-color: rgba(95, 47, 177, 0.6);
}

.rulz {
  font-size: 2.5vh;
}

/////////////////////////////////////////////////////////
.ikonice {
display: grid;
grid-template-columns: repeat(4, 1fr);
grid-template-rows: 1fr;
grid-column-gap: 0px;
grid-row-gap: 0px;
}

.ikonice2 {
display: grid;
grid-template-columns: repeat(4, 1fr);
grid-template-rows: 1fr;
grid-column-gap: 0px;
grid-row-gap: 0px;
}

.div1 { grid-area: 1 / 1 / 2 / 2; }
.div2 { grid-area: 1 / 2 / 2 / 3; }
.div3 { grid-area: 1 / 3 / 2 / 4; }
.div4 { grid-area: 1 / 4 / 2 / 5; }

.sizeup {
width: 25%;
margin: 3vh 0 25vh 0;
filter: grayscale(20%);
transition: all .5s ease-in-out;
}

.yt {
  margin-top: 5vh ;
}


.sizeup:hover {
    scale: 1.1;
    filter: grayscale(0%);
}
/////////////////////////////////////////////////////////

.prijava {
  color: rgb(212, 212, 212);
}

.linkk {
  color: rgb(156, 220, 254);
  text-decoration: underline;
}

@media screen and (max-width: 800px) {
  .shill {
    display: inline-block;
  }

  .ikonice2 {
    display: none;
  }
  .tekst {
    margin: 0;
  }

  .sliks {
    margin: 0;
  }
  .footie {
    float: left;
    text-align: center;
    width: 65%;
  }

  .cutcorner{
    border-width: 50px 0 0 50px;
  }

  .cutcorner1{
    border-width: 50px 50px 0 0;
  }

  .glitch {
    font-size: 10vw;
  }

  .artikl {
    width: 100%;
  }
  .testing {
    margin: 8vh 5vw 5vh 5vw;
  }

  .sizeup {
    margin: 0 0 10vh 0;
    width: 75%;
  }
  .yt{
    margin-top: 1.5vh;
  }
}


</style>